import React, { useEffect, useRef } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import styles from "./DriverConsent.module.scss";

const HolderSignature = props => {
    const { setSignatureData, signatureDate } = props;
    const signatureRef = useRef(null);
    const signDateRef = useRef(null);

    useEffect(() => {
        if (props.signature === "" && signatureRef.current) {
          signatureRef.current.clear();
        }
    }, [props.signature]);

    const clearSignature = () => {
        signatureRef.current.clear();
        setSignatureData("");
    };

    const onDateChange = (e) => {
        let data = e.target.value;
        props.setDateData(data);
        console.log(data);
    };

    const handleEnd = () => {
        const canvas = signatureRef.current.getCanvas();
        const ctx = canvas.getContext('2d');
        ctx.willReadFrequently = true;

        const imageData = signatureRef.current.getTrimmedCanvas().toDataURL("image/png");
        setSignatureData(imageData);
    };

    return (
        <div className={`section ${styles.sectionGrey}`} style={{ backgroundColor: '#f0f0f0', padding: '20px 10px' }}>
            <div className="row">
                <div className="col-md-2">
                    <h3>Licence <br/>holder's<br/>signature</h3>
                </div>
                <div className="col-md-10">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="digital-signed">
                            <div className="name" style={{ width: "100%" }}>
                            <label htmlFor="digitalSigned">
                            Signature*
                            </label>
                            <ReactSignatureCanvas
                                penColor="black"
                                backgroundColor="white"
                                ref={signatureRef}
                                onEnd={handleEnd}
                            />
                            </div>
                        </div>
                        <button className="clear-signature-irr3" onClick={clearSignature} style={{ cursor: "pointer" }}>
                        Clear signature
                        </button>
                    </div>
                    <div className="col-xs-7 col-sm-12 col-md-4">
                        <label htmlFor="signatureDate">
                        Date*
                        </label>
                        <div className="inputbox">
                            <input maxLength="10" type="date" id="signatureDate" name="signatureDate" className="w-100" ref={signDateRef} value={signatureDate} onChange={onDateChange} placeholder="dd/mm/yyyy"
                            required={true} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default HolderSignature;